module.exports = __webpack_public_path__ + "img/bespoke70_12.68b9531b.jpg";